namespace $.$$ {

	$mol_style_define( $bog_gamengine_draw, {

		alignSelf: 'stretch',
		justifySelf: 'stretch',
		minWidth: 0,
		minHeight: 0,
		flex: {
			grow: 1,
			shrink: 1,
			basis: 0,
		},

	} )

}
